import React from 'react'
import styled from 'styled-components'
import { Avatar } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import dayjs from 'dayjs'

type AdditionalDetailsSectionProps = {
  record: any
}

export const AdditionalDetailsSection: React.FC<
  AdditionalDetailsSectionProps
> = ({ record }) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  const loggedBy = record?.loggedBy
  const carerName = loggedBy
    ? `${loggedBy.name?.first || ''} ${loggedBy.name?.last || ''}`.trim()
    : ''
  const timeLogged = record?.timeLogged
    ? dayjs(record.timeLogged).format('DD-MM-YYYY HH:mm')
    : ''
  const media = record?.media || []
  const witnessedBy = record?.witnessedBy

  return (
    <Container>
      {media && media.length > 0 && (
        <InfoItem>
          <StyledLabel level={2}>{t('MEDIA')}</StyledLabel>
          <MediaList>
            {media.map((file: any, index: number) => (
              <MediaItem key={index}>
                {file.name || file.url || `File ${index + 1}`}
              </MediaItem>
            ))}
          </MediaList>
        </InfoItem>
      )}

      {witnessedBy && (
        <InfoItem>
          <StyledLabel level={2}>{t('WITNESSED_BY')}</StyledLabel>
          <Text weight="bold">
            {witnessedBy.name
              ? `${witnessedBy.name.first} ${witnessedBy.name.last}`
              : witnessedBy}
          </Text>
        </InfoItem>
      )}

      <InfoItem>
        <StyledLabel level={2}>{t('TIME_RECORDED')}</StyledLabel>
        <Text>{timeLogged || '-'}</Text>
      </InfoItem>

      <InfoItem>
        <StyledLabel level={2}>{t('RECORDED_BY')}</StyledLabel>
        <RecordedByContainer>
          <Avatar url={loggedBy?.picture as unknown as string} size={32} />
          <Text>{carerName || '-'}</Text>
        </RecordedByContainer>
      </InfoItem>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const StyledLabel = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

const MediaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const MediaItem = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  font-size: 14px;
`

const RecordedByContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
